var React = require('react');

function SortDesc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 1.50078H11V0.300781H0V1.50078Z","key":0}),React.createElement("path",{"d":"M0 5.50078H8V4.30078H0V5.50078Z","key":1}),React.createElement("path",{"d":"M5 9.50078H0V8.30078H5V9.50078Z","key":2}),React.createElement("path",{"d":"M13.9146 7.42848L14.7985 8.31237L10.3792 12.7316L5.95996 8.31238L6.84381 7.42853L9.75488 10.3396L9.75488 3.00078H11.0045V10.3386L13.9146 7.42848Z","key":3})]);
}

SortDesc.defaultProps = {"width":"15","height":"13","viewBox":"0 0 15 13","fill":"none"};

module.exports = SortDesc;

SortDesc.default = SortDesc;
